
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Img1 from "./img/webp/Plafond acoustique textile suspendu pour piscine olympique – solution architecturale UNIK SYSTEM.webp";
import Img2 from "./img/webp/Séparateurs acoustiques textiles design pour bureau moderne – solutions acoustiques UNIK SYSTEM.webp";
import Img3 from "./img/webp/Traitement acoustique professionnel pour studio audio – panneaux muraux et plafond UNIK SYSTEM.webp";

const carouselItems = [
  {
    img: Img1,
    alt:"Architecture textile acoustique pour piscine intérieure – confort sonore et design moderne UNIK SYSTEM",
    subtitle: (
    <>
      <span className="subtitle-us">US</span> ACOUSTIC
    </>
  ),
    title: "Solutions Acoustiques – Absorption & Confort Sonore",
    text: "Réduisez la réverbération et améliorez la qualité sonore grâce aux toiles acoustiques, panneaux absorbants et cadres textiles performants."
  },
  {
    img: Img2,
    alt:"Panneaux acoustiques décoratifs et séparateurs d’espace – architecture intérieure UNIK SYSTEM",
    subtitle: (
    <>
      <span className="subtitle-us">US</span> ACOUSTIC
    </>
  ),
    title: "Panneaux & Cadres Acoustiques Design",
    text: "Des cadres décoratifs acoustiques personnalisables, idéals pour bureaux, restaurants, salles de réunion et espaces professionnels."
  },
  {
    img: Img3,
    alt:"Solution acoustique haute performance pour studio d’enregistrement – UNIK SYSTEM",
    subtitle: (
    <>
      <span className="subtitle-us">US</span> ACOUSTIC
    </>
  ),
    title: "Traitement Acoustique Professionnel",
    text: "Optimisation des espaces avec solutions anti-écho, anti-réverbération et correction acoustique sur mesure."
  }
];


const HeaderCarousel = () => {
  return (
    <div className="container-fluid p-0" id="section1">

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index}>
                      <div className="position-relative">
          
                        {/* IMAGE */}
                        <img className="w-100 hero-img" src={item.img} alt={item.alt} loading="lazy"/>
          
                        {/* OVERLAY */}
                        <div className="hero-overlay d-flex align-items-center">
                          <div className="container">
                            <div  className="col-12 col-lg-8">
          
                              <h5 className="text-uppercase mb-2 text-white fw-bold tracking-in">
                                {item.subtitle}
                              </h5>
          
                              <h1 className="display-3 fw-bold text-white mb-4 slide-down" >
                                {item.title}
                              </h1>
          
                              <p className="fs-5 text-white mb-4 slide-up">
                                {item.text}
                              </p>
          
                              <a href="#titre-gallry" className="btn py-md-3 px-md-5 me-3 slide-left" id="pmt-link">
                                Voir nos réalisations
                              </a>
          
                              <a href="/devis" className="btn py-md-3 px-md-5 slide-left" id="pmt-link2">
                                Demander un devis
                              </a>
          
                            </div>
                          </div>
                        </div>
          
                      </div>
                    </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default HeaderCarousel;

